export default {
    AGUARDANDO: 'Aguardando resposta',
    RESPONDIDO: 'Respondido',
    RASCUNHO: 'Rascunho'
}